module.exports = ''
+ '<div class="creek-shows-container">'
+ '  <creek-shows-nav :shows-nav-text="showsNavText"></creek-shows-nav>'
+ '  <div class="creek-shows-find">'
+ '    <input type="text" v-model="findTerm" placeholder="Find a Show" />'
+ '  </div>'
+ '  <div class="creek-shows">'
+ '    <creek-show :data-show="show" v-for="show in showsFiltered"></creek-show>'
+ '  </div>'
+ '</div>'



// WEBPACK FOOTER //
// ./src/templates/page-shows-all.js